import React from 'react';
import * as S from './UploadFile.styles';
import * as C from '../../Onboarding/Common.styles';

import IconSelector from '@ibibo/icon-selector';
import TickmarkIcon from '../../../icons/Tickmark-white';

export const UploadFile = ({change, toDisabled}) => {
  const valueReset = event => {
    event.target.value = null;
  };

  return (
    <S.UploadLabel htmlFor="panUpload" disabled={toDisabled}>
      <C.CommonInputWrap>
        <S.FullDiv>
          <S.UploadImgMainText>
            Upload <S.BoldText>PAN Card</S.BoldText> photo
          </S.UploadImgMainText>
          <S.SubInfoText>PDF, JPEG only | Below 10MB</S.SubInfoText>
        </S.FullDiv>
        <S.UploadFile
          id="panUpload"
          type="file"
          accept="image/*, .pdf"
          onChange={() => change()}
          onClick={valueReset}
        ></S.UploadFile>
      </C.CommonInputWrap>
    </S.UploadLabel>
  );
};

export const UploadKycDoc = ({change}) => {
  return (
    <S.KYCUploadLabel htmlFor="uploadKYCDoc">
      <S.UploadImgMainText>
        Upload <S.BoldText>KYC Document</S.BoldText>{' '}
      </S.UploadImgMainText>
      <S.SubInfoText>PDF, JPEG only | Below 5MB</S.SubInfoText>
      <S.UploadFile
        id="uploadKYCDoc"
        name="kycdoc"
        type="file"
        accept="image/*"
        onChange={() => change()}
      ></S.UploadFile>
    </S.KYCUploadLabel>
  );
};

export const UploadFacadeDoc = ({change}) => {
  return (
    <S.KYCUploadLabel htmlFor="uploadFacadeDoc">
      <S.UploadImgMainText>
        Upload <S.BoldText>Supporting Document</S.BoldText>{' '}
      </S.UploadImgMainText>
      <S.SubInfoText>PDF, JPEG only | Below 10MB</S.SubInfoText>
      <S.UploadFile
        id="uploadFacadeDoc"
        name="facadedoc"
        type="file"
        accept="image/*"
        onChange={() => change()}
      ></S.UploadFile>
    </S.KYCUploadLabel>
  );
};

export const UploadInfo = ({filesize, filename, reset}) => {
  return (
    <S.UploadedFileInfo>
      <S.ImageInfoWrap>
        <S.UploadImgMainText>{filename}</S.UploadImgMainText>
        <S.SubInfoText>{filesize.toFixed(2)} MB</S.SubInfoText>
      </S.ImageInfoWrap>
      <S.CloseIcon onClick={reset}>x</S.CloseIcon>
    </S.UploadedFileInfo>
  );
};

export const UploadRefresh = ({reset, close}) => {
  return (
    <S.UploadedFileInfo>
      <IconSelector iconKey="file" />
      <S.DocumentTickWrap>
        <IconSelector iconKey="tickmarkwhite" props={{width: '0.8rem', height: '0.8rem'}} />
      </S.DocumentTickWrap>
      {close ? <S.CloseIcon onClick={reset}>x</S.CloseIcon> : ''}
    </S.UploadedFileInfo>
  );
};
